import {React,useState } from 'react';
import { useVirtualRoomStyles } from '../../styles/muiStyles';

import {
    Typography, 
    TextField,
    Button} 
from '@material-ui/core';
import Virtual from '../../assets/svg/virtual.svg'

const VirtualRoom = () => {
    const classes = useVirtualRoomStyles();
    const [btnDisabled, setBtnDisabled] = useState(true)
    const [roomName, setRoomName] = useState("")

    const handleSubmit = () => {
        const win = window.open(`/virtualroom/meeting/${roomName}`, "newwindow");
        win.focus();
    }

    return (
        <div className={classes.row}>
            <div className={classes.column}>
                <img
                    src={Virtual}
                    alt="logo"
                    className={classes.virtualVector}
                />
            </div>
            <div className={classes.column}>
                <Typography  
                    className={classes.title}
                    gutterBottom>
                <strong>Connect <i>everywhere, anytime</i> with NEUMeet</strong>
                </Typography>
                <TextField 
                    id="outlined-basic" 
                    label="Enter meeting ID" 
                    variant="outlined"
                    onInput={(text) => setBtnDisabled(!text.target.value.trim())}
                    onChange={e => setRoomName(e.target.value)}
                    fullWidth 
                />
                <Button
                    size="large"
                    color="primary"
                    variant="contained"
                    onClick={handleSubmit}
                    disabled={btnDisabled}
                    fullWidth
                    className={classes.join}
                    type="submit"
                    >
                    Start or Join Meeting
                </Button>
            </div>
        </div>
    );
};
export default VirtualRoom;
